import { jarvisPrimeInvestMoreConstants } from "./jarvisPrimeInvestMoreConstants";

const jarvisPrimeInvestMoreActions = {};

jarvisPrimeInvestMoreActions.getInvestmentStocks = () => {
    return {
        type: jarvisPrimeInvestMoreConstants.PRIME_INVESTMENT_STOCKS_SAGA,
    };
};

export { jarvisPrimeInvestMoreActions };
